import { useEffect, useState } from "react";
import { http } from "../../lib/api";

const when = (iso) => new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export default function WhatsAppTab() {
  const [rows, setRows] = useState(null);
  useEffect(() => { http.get("/analytics/whatsapp-clicks").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <div className="chart-empty">Loading…</div>;
  const byPlacement = rows.reduce((a, r) => ({ ...a, [r.placement]: (a[r.placement] || 0) + 1 }), {});
  return (
    <>
      <div className="admin-top"><h1>WhatsApp click tracking</h1><span className="badge neutral big" data-testid="whatsapp-total">{rows.length} clicks</span></div>
      <div className="pill-row" data-testid="whatsapp-placements">{Object.entries(byPlacement).map(([k, v]) => <span key={k} className="pill"><b>{v}</b> {k}</span>)}</div>
      <div className="leads-table-wrap">
        <table className="leads-table" data-testid="whatsapp-table">
          <thead><tr><th>Time</th><th>Page</th><th>Button</th><th>Product</th><th>Visitor</th></tr></thead>
          <tbody>{rows.map((r) => <tr key={r.click_id} data-testid={`whatsapp-row-${r.click_id}`}><td>{when(r.created_at)}</td><td>{r.page}</td><td><span className="badge ok">{r.placement}</span></td><td>{r.product || "—"}</td><td className="mono">{(r.visitor_id || "anon").slice(0, 8)}</td></tr>)}</tbody>
        </table>
        {rows.length === 0 && <div className="empty-state" data-testid="empty-whatsapp-state">No WhatsApp clicks recorded yet.</div>}
      </div>
    </>
  );
}
